/**
 * @author Kvadrat
 * This file contains code copied from:
 * https://github.com/inter-ikea/cbf-re-ipex-kvadrat
 */

type InFrResponse = {
  inches: number;
  fractions: string | null;
};

// https://stackoverflow.com/questions/14002113/how-to-simplify-a-decimal-into-the-smallest-possible-fraction
function getLowestFraction(x0: number): string {
  if (x0 === 0) {
    return '';
  }

  const eps = 1.0e-15;
  let h;
  let h1;
  let h2;
  let k;
  let k1;
  let k2;
  let a;
  let x;

  x = x0;
  a = Math.floor(x);
  h1 = 1;
  k1 = 0;
  h = a;
  k = 1;

  while (x - a > eps * k * k) {
    x = 1 / (x - a);
    a = Math.floor(x);
    h2 = h1;
    h1 = h;
    k2 = k1;
    k1 = k;
    h = h2 + a * h1;
    k = k2 + a * k1;
  }

  return `${h}/${k}`;
}

/**
 * Rounding to the nearest eight
 * @param fraction
 * @returns Nearest eight
 */
export function roundFraction(fraction: number): number {
  return Math.round(fraction * 8) / 8;
}

/**
 * Converts inches to inches and fractional inches
 * @param inches Inches
 * @returns Inches and fractional inches
 */
export function inToInFr(inches: number): InFrResponse {
  const roundInches = Math.round(inches * 1000) / 1000;
  const inchFractions = roundInches % 1;

  return {
    inches: roundInches - inchFractions,
    fractions: getLowestFraction(roundFraction(inchFractions))
  };
}
